<template>
  <v-fab-transition>
    <v-btn
      fixed
      bottom
      @click="scrollToTop"
      right
      fab
      color="transparent"
      v-scroll="CheckScrollStatus"
      v-show="active"
    >
      <!-- color="primary" -->
      <!-- <v-icon>mdi-chevron-up</v-icon> -->
      <v-img
        :src="require(`@/assets/imgs/${imgSrc}.png`)"
        contain
        max-width="50px"
      />
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  data: () => ({
    active: false,
    imgSrc: "scroll-to-top-not",
  }),
  methods: {
    CheckScrollStatus() {
      const check = 100;
      if (window.scrollY > check) {
        this.active = true;
      } else {
        this.active = false;
        this.imgSrc = "scroll-to-top-not";
      }
    },
    scrollToTop() {
      this.imgSrc = "scroll-to-top";
      window.scrollTo({ top: 0, behavior: "smooth" });
      //
    },
  },
};
</script>

<style lang="scss" scoped>
</style>